/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class ProcessActionsModel {

        private systemActions: Wars.Domain.Model.SystemAction[];
        private processActions: Wars.Domain.Model.ProcessAction[];
        private currentProcessAction: Wars.Domain.Model.ProcessAction;
        private processSchemaProperties: Wars.Domain.Model.SchemaProperty[];
        public search: any;

        constructor(
            private processConfigId: string,
            private processActionService: services.ProcessActionService,
            private deleteService: services.DeleteService,
            private systemLevelService: services.SystemLevelService,
            private processConfigurationService: services.ProcessConfigurationService,
            private newProcessActionSelectedCallback: (processActionGroup: models.ProcessActionGroup) => void,
            private processActionId: string)
        {
            this.processActionService.getAllProcessActions(this.processConfigId).then(
                (processActions) => {
                    this.processActions = processActions;
                    if (processActionId) {
                        this.currentProcessAction = Enumerable.from(this.processActions).singleOrDefault(i => i.id === processActionId);
                        this.loadProcessActionInfo();
                    }
                });

            this.processConfigurationService.getProcessSchemaProperties(this.processConfigId).then(
                (schemaProperties) => {
                    this.processSchemaProperties = schemaProperties;
                });

            this.systemLevelService.getSystemLevelSystemActions().then(
                (systemLevel) => {
                    this.systemActions = systemLevel.mySystemActions;
                });

            this.search = {
                name: ''
            }
        }

        public addNewProcessAction(): void {
            this.currentProcessAction = this.processActionService.createNewProcessAction(this.processConfigId);
            this.processActionService.saveAllChanges(() => {
                this.processActions.push(this.currentProcessAction);
                this.loadProcessActionInfo();
            });
        }

        public save() {
            this.processActionService.saveAllChanges();
        }

        public deleteProcessAction() {
            this.deleteService.deleteWithModalConfirmIfNecessary(
                "ProcessAction",
                this.currentProcessAction.id,
                "Process Action",
                () => {
                    this.processActions.remove(this.currentProcessAction);
                    this.currentProcessAction = undefined;
                    this.loadProcessActionInfo();
                });
        }

        public loadProcessActionInfo(): void {
            if (this.currentProcessAction) {
                this.processActionService.getProcessActionGroup(this.currentProcessAction.id).then(
                (processActionGroup: models.ProcessActionGroup) => {
                    this.newProcessActionSelectedCallback(processActionGroup);
                });
            } else {
                this.newProcessActionSelectedCallback(undefined);
            }
        }
    }
}